import React, { useCallback } from "react";
import { Metric } from "@linkfluence/models/metric";
import Checkbox from "@ui-kit/form/checkbox";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { getPrimaryMetricFromCard } from "@radarly/models/cards/metric";
import { DatavizKpi, updateDatavizOptions } from "@radarly/models/dataviz";
import PeriodEvolution from "../shared/period-evolution";

export interface SharedPanelsCardEditionSidebarOptionsKpiProps {
  dataviz: DatavizKpi;
  setDataviz: (dataviz: DatavizKpi) => void;
  setCard?: (card: Card) => void;
  card?: Card;
  color: React.ReactElement;
}

const isColorPickerAllowed = (card: Card) => {
  const metric = getPrimaryMetricFromCard(card);
  return metric !== Metric.NetSentiment;
};

export default function SharedPanelsCardEditionSidebarOptionsKpi({
  dataviz,
  setDataviz,
  setCard,
  card,
  color,
}: SharedPanelsCardEditionSidebarOptionsKpiProps) {
  const allowColorPicker = isColorPickerAllowed(card);
  const updateDisplayDistributions = useCallback(() => {
    const value = dataviz.displayDistributions ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "displayDistributions",
        value as DatavizKpi["displayDistributions"]
      )
    );
  }, [dataviz, setDataviz]);

  const locale = useCurrentUserLocale();

  return (
    <>
      <PeriodEvolution card={card} setCard={setCard} />
      <Checkbox
        label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SPARLINE_DISPLAY")}
        checked={dataviz.displayDistributions || undefined}
        onClick={updateDisplayDistributions}
      />
      {dataviz.displayDistributions && allowColorPicker && color}
    </>
  );
}
